module.exports = __webpack_public_path__ + "img/icon-venue.2688ce8d.png";